var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.616-329.231q0-67.923 15.654-104 15.654-36.076 65.347-80 38.692-34.461 58.653-62.5 19.962-28.038 19.962-63.577 0-47.154-32.116-78.385t-88.424-31.231q-51.385 0-80 27.538-28.616 27.538-43.462 61.461l-72.998-32.076q23.308-57.461 72.769-95.806 49.461-38.346 123.691-38.346 96.923 0 149.192 54.654 52.268 54.653 52.268 129.73 0 46.923-20.346 82.807-20.346 35.885-61.73 74.731-52.077 47.769-64.5 75.346-12.424 27.577-12.424 79.654h-81.536Zm39.076 229.23q-24.538 0-42.268-17.731-17.73-17.73-17.73-42.268t17.73-42.268q17.73-17.731 42.268-17.731t42.268 17.731q17.731 17.73 17.731 42.268t-17.731 42.268q-17.73 17.731-42.268 17.731Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.5100797c58692b40d59daedc91c02472.svg";
export { ForwardRef as ReactComponent };